import { createSelector } from 'reselect';
import _uniq from 'lodash/uniq';
import cookie from 'cookie-cutter';
import { isEmpty } from 'lib/util';
import canUseDOM from 'lib/util/canUseDOM';
import { subscriptionsSelector } from 'common/selectors/authenticationSelectors';
import fanSelector from 'common/selectors/fanSelector';

const oneIdSelector = ({ oneId = {} }) => oneId;

export default createSelector(oneIdSelector, (oneId) => oneId);

export const oneIdInitializedSelector = createSelector(
    oneIdSelector,
    (oneId) => oneId && !!oneId.completeTime
);

export const oneIdLoggedInSelector = createSelector(
    oneIdSelector,
    (oneId) => {
        if (canUseDOM && window.espn && window.espn.core && window.espn.core.loggedIn != null) {
            return window.espn.core.loggedIn;
        }
        return oneId && !isEmpty(oneId.data);
    }
);

export const oneIdLangPrefSelector = createSelector(
    oneIdSelector,
    (oneId) => {
        let langPref;
        if (oneId && !isEmpty(oneId.data)) {
            langPref = oneId.data.profile.languagePreference;
        }
        return langPref;
    }
);

export const oneIdEntitlementsSelector = createSelector(
    subscriptionsSelector,
    oneIdSelector,
    (subscriptions, oneId) => {
        let entitlements;
        if (subscriptions) {
            entitlements = _uniq(subscriptions.reduce((acc, { isActive, products = [], status: { type } = {} }) => {
                if (!isActive || type === 'UNSUBSCRIBED') {
                    return acc;
                }
                const prdctEntitlements = products.reduce((acc2, { partner, entitlements: productEntitlements = [] }) => {
                    if (partner !== 'ESPN' && partner !== 'disney') {
                        return acc2;
                    }
                    return acc2.concat(productEntitlements.map(({ name }) => name));
                }, []);
                return acc.concat(prdctEntitlements);
            }, []));
            return entitlements;
        }
        // fall back to use info from OneID
        if (oneId && !isEmpty(oneId.data) && oneId.data.entitlements && oneId.data.entitlements.length) {
            entitlements = oneId.data.entitlements
                .filter(({ digitalAssetName }) => digitalAssetName === 'ESPNPLUS')
                .map(({ digitalAssetSourceName }) => digitalAssetSourceName);
        }
        return entitlements;
    }
);

export const oneIdTokenSelector = createSelector(
    oneIdSelector,
    (oneId) => oneId && oneId.data && oneId.data.token
);

export const oneIdEntitlementsParamsSelector = createSelector(
    oneIdEntitlementsSelector,
    (oneIdEntitlements) => oneIdEntitlements
);

function convertGender(gender) {
    return {
        1: 'M',
        2: 'F'
    }[gender] || 'not set';
}

export const oneIdAnalyticsSelector = createSelector(
    fanSelector,
    oneIdSelector,
    (fan, oneId) => {
        const { data } = oneId || {};
        const swid = fan.id || (typeof document !== 'undefined' && cookie.get('SWID'));
        const unid = fan.id || (typeof document !== 'undefined' && cookie.get('UNID'));
        const tracking = { swid, unid };
        if (!isEmpty(data)) {
            const { profile: { status, gender = '', dateOfBirth = '' } = {} } = data;
            tracking.registrationtype = 'espn';
            if (status) {
                tracking.loginstatus = `Registered:Logged in ${status}`;
            }
            tracking.gender = convertGender(gender);
            if (dateOfBirth) {
                tracking.birthage = dateOfBirth.slice(0, 4);
            }
        }
        return tracking;
    }
);



// WEBPACK FOOTER //
// ./app/common/selectors/oneIdSelector.js